module.exports = __webpack_public_path__ + "static/media/vodafone-regular.bd9e4acf.woff";